import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Neutral chip for tags/categories. */
export function Pill({ children, className, mono }: { children: ReactNode; className?: string; mono?: boolean }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-hairline bg-subtle px-2 py-0.5 text-2xs text-ink-muted',
        mono && 'font-mono',
        className,
      )}
    >
      {children}
    </span>
  );
}
